import { Injectable } from "@angular/core";
import { DialogResult, ButtonsType, IconType, NotificationType, NotificationPosition } from "app/@core/enum/notification-options.enum";
import alertify from "alertifyjs";
import "style-loader!alertifyjs/build/css/alertify.css";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class NotificationUtilService {
    router: Router;
    readonly DEFAULT_TIME_SECONDS: number = 5;

    constructor(
        http: HttpClient,
        router: Router,
        private translateService: TranslateService
    ) {
        this.router = router;
        this.setDefaultStyles();
    }


    setDefaultStyles() {
        this.setNotifyStyle('success', '#198754', '#FFFFFF');
        this.setNotifyStyle('error', '#dc3545', '#FFFFFF'); 
        this.setNotifyStyle('warning', '#FFDA66 ', '#FFFFFF');
    }

    setNotifyStyle(NotificationType, backgroundColor, textColor) {
        const style = document.createElement('style');
        style.innerHTML = `
            .alertify-notifier .ajs-message.ajs-${NotificationType} {
                background: ${backgroundColor};
                color: ${textColor};
                border-radius: 8px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                position: relative;
                padding-right: 30px;
            }
            
            .alertify-notifier .ajs-message.ajs-${NotificationType}::before {
                content: '×';
                font-size: 18px;
                font-weight: bold;
                color: ${textColor};
                position: absolute;
                top: 5px;
                right: 10px;
                cursor: pointer;
            }
            .alertify-notifier .ajs-message.ajs-${NotificationType}::before:hover {
                color: rgba(255, 255, 255, 0.8);
            }
        `;
        document.head.appendChild(style);
    }

    notify(
      message: string,
      notificationType: NotificationType,
      position: NotificationPosition = NotificationPosition.BOTTOM_RIGHT,
      timeSeconds: number = this.DEFAULT_TIME_SECONDS
      ) {

        alertify.set("notifier", "delay", timeSeconds);

        switch (position) {

          case NotificationPosition.TOP_RIGHT:
            alertify.set("notifier", "position", "top-right");
            break;
            
          case NotificationPosition.TOP_CENTER:
            alertify.set("notifier", "position", "top-center");
            break;

          case NotificationPosition.TOP_LEFT:
            alertify.set("notifier", "position", "top-left");
            break;

          case NotificationPosition.BOTTOM_RIGHT:
            alertify.set("notifier", "position", "bottom-right");
            break;

          case NotificationPosition.BOTTOM_CENTER:
            alertify.set("notifier", "position", "bottom-center");
            break;

          case NotificationPosition.BOTTOM_LEFT:
            alertify.set("notifier", "position", "bottom-left");
            break;
        }

        switch (notificationType) {
            case NotificationType.SUCCESS: {
                alertify.success(message);
                break;
            }
            case NotificationType.ERROR: {
                alertify.error(message);
                break;
            }

            case NotificationType.WARNING: {
                alertify.warning(message);
                break;
            }
            case NotificationType.INFO: {
                alertify.notify(message);
                break;
            }

            default: {
                break;
            }
        }
    }

    openConfirmationDialog(
        title: string,
        message: string,
        okCallback?: () => any,
        cancelCallback?: () => any,
    ) {
        this.openDialog(message, title, IconType.WARNING, ButtonsType.OK_CANCEL, (result: DialogResult) => {
          if(result == DialogResult.OK && okCallback) okCallback();
          else if(result == DialogResult.CANCEL && cancelCallback) cancelCallback();
        });
    }

    printSuccessMessage(message: string) {
      this.openDialog(message, "", IconType.SUCESS, ButtonsType.OK);
    }

    printErrorMessage(message: string) {
      this.openDialog(message, "", IconType.ERROR, ButtonsType.OK);
    }

    printWarningMessage(message: string) {
        this.openDialog(message, "", IconType.WARNING, ButtonsType.OK);
    }

    openDialog(
        message: string,
        title: string = "",
        icon: IconType = IconType.NONE,
        buttons: ButtonsType = ButtonsType.OK,
        resultCallback?: (dialogResult: DialogResult, value?: string) => any,
        customButtons?: string[]
    ) {
        alertify.defaults.transition = "slide";
        alertify.defaults.theme.ok = "btn btn-creare";
        alertify.defaults.theme.cancel = "btn btn-danger";
        alertify.defaults.theme.input = "form-control";

        var buttonList = [];

        /*
        TODO: Corrigir bug de tradução com classes injetadas.
        No momento nao esta funcionando, vai ficar em ingles mesmo.

        var retryButton = {text: this.getTranslateSubs('GLOBAL.retry'), className: alertify.defaults.theme.ok, resultType: DialogResult.RETRY}
        var cancelButton = {text: this.getTranslateSubs('GLOBAL.cancel'), className: alertify.defaults.theme.ok, resultType: DialogResult.CANCEL}
        var okButton = {text: this.getTranslateSubs('GLOBAL.ok'), className: alertify.defaults.theme.ok, resultType: DialogResult.OK}
        var continueButton = {text: this.getTranslateSubs('GLOBAL.continue'), className: alertify.defaults.theme.ok, resultType: DialogResult.CONTINUE}
        var yesButton = {text: this.getTranslateSubs('GLOBAL.yes'), className: alertify.defaults.theme.ok, resultType: DialogResult.YES}
        var noButton = {text: this.getTranslateSubs('GLOBAL.no'), className: alertify.defaults.theme.ok, resultType: DialogResult.NO}
        */

        var retryButton = {
            text: "Retry",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.RETRY
        };
        var cancelButton = {
            text: "Cancel",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.CANCEL
        };
        var okButton = {
            text: "Ok",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.OK
        };
        var continueButton = {
            text: "Continue",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.CONTINUE
        };
        var yesButton = {
            text: "Yes",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.YES
        };
        var noButton = {
            text: "No",
            className: alertify.defaults.theme.ok,
            resultType: DialogResult.NO
        };

        let modifiedCancelButton = {...cancelButton, invokeOnClose: true}
        let modifiedOkButton = {...okButton, invokeOnClose: true}
        let modifiedNoButton = {...noButton, invokeOnClose: true}
        
        switch (buttons) {
            case ButtonsType.CANCEL_RETRY_CONTINUE:
                buttonList = [modifiedCancelButton, retryButton, continueButton];
                break;
            case ButtonsType.OK:
                buttonList = [modifiedOkButton];
                break;
            case ButtonsType.OK_CANCEL:
                buttonList = [okButton, modifiedCancelButton];
                break;
            case ButtonsType.RETRY_CANCEL:
                buttonList = [retryButton, modifiedCancelButton];
                break;
            case ButtonsType.YES_NO:
                buttonList = [yesButton, modifiedNoButton];
                break;
            case ButtonsType.YES_NO_CANCEL:
                buttonList = [yesButton, noButton, modifiedCancelButton];
                break;
            case ButtonsType.CUSTOM:
                buttonList = customButtons.map(button => {
                    return {
                        text: button,
                        className: alertify.defaults.theme.ok,
                        resultType: DialogResult.CUSTOM
                    };
                });
        }

        var iconStyle = "";
        var iconColor = "";

        switch (icon) {
            case IconType.ERROR:
                iconStyle = "fa-times-circle";
                iconColor = "#e10000";
                break;
            case IconType.INFO:
                iconStyle = "fa-exclamation";
                iconColor = "#000080";
                break;
            case IconType.SUCESS:
                iconStyle = "fa-check-circle";
                iconColor = "#00e100";
                break;
            case IconType.WARNING:
                iconStyle = "fa-exclamation";
                iconColor = "#F3DB05";
                break;
            case IconType.SEVERE_WARNING:
                iconStyle = "fa-exclamation";
                iconColor = "#e10000";
                break;
        }

        if (alertify.notificationDialog) {
            delete alertify.notificationDialog;
        }

        alertify.dialog("notificationDialog", function factory() {
            return {
                main: function(message) {
                    this.message = message;
                },
                setup: function() {
                    return {
                        buttons: buttonList,
                        focus: { element: 0 },
                        options: { title: title, maximizable: false }
                    };
                },
                prepare: function() {
                    this.setContent(this.message);
                },
                build: function() {
                    var headerIcon =
                        `<span class="fa ${iconStyle} fa-2x" ` +
                        `style="vertical-align:middle;color:${iconColor};">` +
                        `</span>`;
                    var headerTitle = `<span style="margin-left:12px">${title}</span>`;
                    this.setHeader(
                        icon !== IconType.NONE
                            ? headerIcon + headerTitle
                            : title
                    );
                },
                callback: function(closeEvent) {
                    if (resultCallback)
                        resultCallback(
                            closeEvent.button.resultType,
                            closeEvent.button.text
                        );
                }
            };
        });

        alertify.notificationDialog(message);
    }
}
